import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import api from "../lib/api";
import VerdictBadge from "../components/VerdictBadge";
import { Button } from "@/components/ui/button";
import { FileText, ArrowRight } from "lucide-react";

export default function History() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/cos/history");
        setItems(data);
      } catch {
        setItems([]);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <SiteHeader />
      <main className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">History</div>
            <h1 className="font-heading text-4xl font-bold tracking-tight mt-2">Your past checks</h1>
          </div>
          <Link to="/app">
            <Button className="rounded-sm bg-[#0F172A] hover:bg-[#0F172A]/90" data-testid="history-new-check-btn">
              New check <ArrowRight className="w-4 h-4" />
            </Button>
          </Link>
        </div>

        <div className="mt-8 border border-zinc-200 bg-white rounded-sm overflow-hidden">
          {items === null ? (
            <div className="p-10 text-center text-zinc-500 font-mono text-sm">Loading…</div>
          ) : items.length === 0 ? (
            <div className="p-10 text-center" data-testid="history-empty">
              <FileText className="w-8 h-8 mx-auto text-zinc-400" />
              <div className="font-heading text-xl font-semibold mt-3">No checks yet</div>
              <div className="text-sm text-zinc-500 mt-1">Run your first verification to see it here.</div>
            </div>
          ) : (
            <table className="w-full text-sm" data-testid="history-table">
              <thead className="bg-zinc-50 border-b border-zinc-200">
                <tr className="text-left">
                  <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">File</th>
                  <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Analysed</th>
                  <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Score</th>
                  <th className="px-4 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Verdict</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody>
                {items.map((it) => (
                  <tr key={it.id} className="border-b border-zinc-100 last:border-0 hover:bg-zinc-50">
                    <td className="px-4 py-3 font-mono text-xs truncate max-w-[280px]" data-testid={`history-row-file-${it.id}`}>
                      {it.filename}
                      {it.is_own === false && (
                        <span className="ml-2 font-mono text-[10px] uppercase tracking-[0.15em] px-1.5 py-0.5 rounded-sm bg-zinc-100 text-zinc-600 border border-zinc-300">Team</span>
                      )}
                    </td>
                    <td className="px-4 py-3 font-mono text-xs text-zinc-500">
                      {new Date(it.created_at).toLocaleString()}
                    </td>
                    <td className="px-4 py-3 font-mono text-lg font-bold">{it.final_score}</td>
                    <td className="px-4 py-3"><VerdictBadge verdict={it.final_verdict} /></td>
                    <td className="px-4 py-3 text-right">
                      <Link to={`/app/result/${it.id}`} className="font-mono text-xs text-[#0F172A] underline underline-offset-4" data-testid={`history-view-${it.id}`}>
                        View →
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </main>
    </div>
  );
}
